import { UserGet } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";

export const makeMe = ({ connection }: ApiSliceParams) => {
    const user = signal<UserGet | null>(null);
    const loading = signal(false);
    const loaded = signal(false);

    const listen = async () => {
        const con = connection.value;

        loading.value = true;

        for await (const item of con.user.service.get({
            id: [con.user.user_id],
        })) {
            user.value = item;
        }

        loading.value = false;
        loaded.value = true;
    };

    return {
        user,
        loading,
        loaded,
        listen,
    };
};
